// // src/firebase.js
// import { initializeApp } from 'firebase/app';
// import { getAuth } from 'firebase/auth';
// import { getAnalytics } from "firebase/analytics";
import firebase from 'firebase/compat/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import 'firebase/compat/firestore';
import { getDatabase, ref, set, get, child, onValue } from "firebase/database";
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getStorage, uploadBytes, getDownloadURL } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBnPt93hSlSHh6cXt6lvpk3JpyrZLP61B0",
  authDomain: "pravasa-ef1a9.firebaseapp.com",
  databaseURL: "https://pravasa-ef1a9-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "pravasa-ef1a9",
  storageBucket: "pravasa-ef1a9.firebasestorage.app",
  messagingSenderId: "950806999863",
  appId: "1:950806999863:web:5efad48a0280b2e2ed60b2",
  measurementId: "G-2PHX07RS5M"
};

const secondaryFirebaseConfig = {
  apiKey: "AIzaSyBnPt93hSlSHh6cXt6lvpk3JpyrZLP61B0",
  authDomain: "pravasa-ef1a9.firebaseapp.com",
  databaseURL: "https://pravasa-ef1a9-bd136.asia-southeast1.firebasedatabase.app/",
  projectId: "pravasa-ef1a9",
  storageBucket: "pravasa-ef1a9.firebasestorage.app",
  messagingSenderId: "950806999863",
  appId: "1:950806999863:web:5efad48a0280b2e2ed60b2",
  measurementId: "G-2PHX07RS5M"
};
// const firestoreFirebaseConfig = {
//   apiKey: "AIzaSyBnPt93hSlSHh6cXt6lvpk3JpyrZLP61B0",
//   authDomain: "pravasa-ef1a9.firebaseapp.com",
//   projectId: "pravasa-ef1a9",
//   storageBucket: "pravasa-ef1a9.firebasestorage.app",
//   messagingSenderId: "950806999863",
//   appId: "1:950806999863:web:5efad48a0280b2e2ed60b2",
//   measurementId: "G-2PHX07RS5M"
// };
// For Firebase JS SDK v7.20.0 and later, measurementId is optional


// const firestoreApp = initializeApp(firestoreFirebaseConfig,"primary");


// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// const auth = getAuth(app);

// // auth.settings.appVerificationDisabledForTesting = true;

// export { auth };

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const secondApp = firebase.initializeApp(secondaryFirebaseConfig,'secondary');
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
// auth.settings.appVerificationDisabledForTesting = true; // Use only in development!

//init services 
const projectFirebase = firebase.firestore()
const database = getDatabase(app);
const secondaryDatabase = getDatabase(secondApp);


export { auth, firebaseConfig,secondaryFirebaseConfig,  RecaptchaVerifier, signInWithPhoneNumber , projectFirebase , database, secondaryDatabase,storage,db, ref, set, get, child, onValue};